export default "__VITE_ASSET__B1IjNYfj__"